import { getFunctions, httpsCallable } from 'firebase/functions';

// Una única puerta para mutaciones administrativas de cuentas registradas.
// El servidor vuelve a verificar sesión, Owner y último Owner en cada petición.
export async function guardarUsuario(targetUid, cambios) {
  const result = await httpsCallable(getFunctions(), 'gestionarUsuario')({ targetUid, cambios });
  return result.data;
}

export async function eliminarUsuario(targetUid) {
  const result = await httpsCallable(getFunctions(), 'eliminarUsuario')({ targetUid });
  return result.data;
}

export async function obtenerEstadoOwners() {
  const result = await httpsCallable(getFunctions(), 'obtenerEstadoOwners')({});
  return result.data;
}
